<template>
  <div class='build-updates-component card bg-parchment mb-3'>
    <div class="card-body d-flex flex-column flex-lg-row justify-content-lg-between gap-35">
      <div>
        <h4 class="h5 text-dark font-albra-medium mb-1">
          <em class="font-weight-normal">Your</em> Home Updates - {{ currentUpdate + 1 }} of {{ updates.length }}
        </h4>

        <div v-for="update in updates" :key="update.id">
          <transition name="fade" mode="out-in">
            <h5 v-show="updates.at(currentUpdate).id === update.id" :key="`h5-${update.id}`"
                class="fs-4 text-peach font-albra-medium mb-4">
              {{ update.title }}
            </h5>
          </transition>

          <transition name="fade" mode="out-in">
            <p v-show="updates.at(currentUpdate).id === update.id" :key="`p-${update.id}`"
               class="text-dark font-size-14">{{ update.summary }}</p>
          </transition>
        </div>

        <div class="date-progress-container d-none d-lg-block">
          <p class="font-size-14 text-light mb-0">Update: {{ updates.at(currentUpdate).created_string }}</p>

          <div class="d-flex align-items-center ms-n3">
            <button class="btn btn-icon text-dark" @click="currentUpdate = currentUpdate - 1"
                    :disabled="currentUpdate === 0">
              <i class="fas fa-chevron-left"></i>
            </button>

            <div class="progress position-relative w-100" role="progressbar" aria-label="build updates progress"
                 :aria-valuenow="currentUpdate + 1 / updates.length * 100" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar position-absolute top-0 h-100"
                   :style="`width: ${1 / updates.length * 100}%; left: ${currentUpdate / updates.length * 100}%;`"></div>
            </div>

            <button class="btn btn-icon text-dark" @click="currentUpdate = currentUpdate + 1"
                    :disabled="currentUpdate === updates.length - 1">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <div>
        <div v-for="update in updates" :key="update.id">
          <a :href="update.image" target="_blank">
            <transition name="fade" mode="out-in">
              <img
                v-if="updates.at(currentUpdate).id === update.id"
                :src="update.image"
                width="200"
                height="200"
                :alt="update.title + ' build update'"
                class="object-fit-cover w-fit rounded-2"
                style="max-width: unset;"
              />
            </transition>
          </a>
        </div>
      </div>

      <div class="date-progress-container d-lg-none">
        <p class="font-size-14 text-light mb-0">Update: {{ updates.at(currentUpdate).created_string }}</p>

        <div class="d-flex gap-3 align-items-center">
          <button class="btn btn-icon text-dark" @click="currentUpdate = currentUpdate - 1"
                  :disabled="currentUpdate === 0">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="progress position-relative w-100" role="progressbar" aria-label="build updates progress"
               :aria-valuenow="currentUpdate + 1 / updates.length * 100" aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar position-absolute top-0 h-100"
                 :style="`width: ${1 / updates.length * 100}%; left: ${currentUpdate / updates.length * 100}%;`"></div>
          </div>

          <button class="btn btn-icon text-dark" @click="currentUpdate = currentUpdate + 1"
                  :disabled="currentUpdate === updates.length - 1">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BuildUpdatesComponent",
  props: {
    updates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentUpdate: 0,
    }
  },
}
</script>

<style scoped lang="scss">
.date-progress-container {
  &.d-lg-block {
    max-width: 18rem;
  }

  .progress-bar {
    transition: left 0.2s ease-in-out;
  }
}

.fade-enter-active {
  transition: opacity .5s;
}

.fade-leave-active {
  display: none;
  transition: opacity .1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>
